import axios from 'axios';
import { isLoggedIn } from '../auth';

/**
 * Fetches the a user using the id
 * @param {Number} id - id of user
 * @returns {Promise} user - a promise of user to be resolved.
 */
export function getUserProfile(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}

/**
 * Uploads an logo
 * @returns {promise} a promise of job applicants
 */
export function uploadLogo(id, file) {
	if (isLoggedIn()) {
		return axios.post(`/v1/employer/${id}/logo`, file);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403,
		statusText: 'Unauthorised'
	}));
}

/**
 * Fetches the quizzes a user has taken
 * @param {Number} id - id of user
 * @returns {Promise} quizzes - a promise of quizzes to be resolved.
 */
export function getUserQuizResponse(id) {
	if (isLoggedIn) {
		return axios.get(`/v1/quizresponses/${id}/user`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}
/**
 * Fetches the a users certificates
 * @param {Number} id - id of certificate user  
 * @returns {Promise} user - a promise of user to be resolved.
 */
export function getCertificates(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/certificates`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}

/**
 * Updates a user
 * @param {Number} id - Id of the user to be updated
 * @param {Object} userData - the user data object
 * @returns {Promise} user - a promise of the updated user.
 */
export function updateUser(id, userData) {
	if (isLoggedIn()) {
		return axios.patch(`/v1/users/${id}`, userData);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}

/**
 * Updates a user's avatar
 * @param {Number} id - Id of the user to be updated
 * @param {Object} avatar - the base64 image object to be updated
 * @returns {Promise} a promise of the updated user.
 */
export function updateAvatar(id, avatar) {
	if (isLoggedIn()) {
		return axios.patch(`v1/users/${id}/avatar`, { file: avatar });
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

/**
 * Uploads user credentials
 * @param {Number} id - Id of the user to be updated
 * @param {Object} credentials - the user's credentials object
 * @returns {Promise} user - a promise of the updated user.
 */
export function uploadCredential(id, credential) {
	if (isLoggedIn()) {
		return axios.post('v1/credentials', credential);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

/**
 * Fetches an array of all credentials
 * @returns {Promise} a promise of the array of credentials.
 */
export function getUserCredentials(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/credentials`);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

/**
 * Fetches a list of Users certificates
 * @param {Number} id of user
 * @return {Promise} a promise of user certificates to be returned 
 */
export function getUserCertificates(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/certificates`);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

/**
 * Fetches a list of Users quizscores
 * @param {Number} id of user
 * @return {Promise} a promise of user scores to be returned 
 */
export function getUserScores(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/scores/${id}/user`);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

/* Updates a user's bank
 * @param {Number} id - Id of the user to be updated
 * @param {Object} userData - the user data object
 * @returns {Promise} user - a promise of the updated user.
 */
export function updateBank(id, userData) {
	if (isLoggedIn()) {
		return axios.patch(`/v1/users/${id}/bank`, userData);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}

/* Updates a user's bank
 * @param {Number} id - ID of the credential to be deleted
 * @param {Number} userId - ID of the user
 * @returns {Promise} user - a promise of the updated user.
 */
export function deleteCredential(id, userId) {
	if (isLoggedIn()) {
		return axios.delete(`/v1/credentials/${id}/user/${userId}`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403, statusText: 'Unauthorised'
	}));
}

/**
 * Fetches a list of user's job
 * @param {Number} id of user
 * @return {Promise} a promise of user scores to be returned 
 */
export function getUserJobs(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/jobs`);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}

export function getUserBadges(id) {
	if (isLoggedIn()) {
		return axios.get(`v1/users/${id}/badges`);
	}
	return Promise.resolve(new Response(
		{
			message: 'Unauthorised'
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}